import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  SetLens2527bvop19mpo as SetLens,
  ModifyLens104zsbx7gwa6e as ModifyLens,
  SetValueLensuxj8ukufftbv as SetValueLens,
  ModifyValueLenspp00mwqm1elc as ModifyValueLens,
} from '../lensing/abstracts.mjs';
import { _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b } from './ReactiveState.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function Reactive$Companion$reportException$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        tmp.xaj_1 = Reactive$Companion$reportException$lambda;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ReactiveClass;
function Reactive() {
  if (ReactiveClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Reactive', VOID, VOID, [Listenable()]);
    ReactiveClass = $;
  }
  return ReactiveClass;
}
function lens(get, set) {
  return SetLens().cap(this, get, set);
}
function lens_0(get, modify) {
  return ModifyLens().jap(this, get, modify);
}
var MutableReactiveClass;
function MutableReactive() {
  if (MutableReactiveClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableReactive', VOID, VOID, [Reactive()], [1]);
    MutableReactiveClass = $;
  }
  return MutableReactiveClass;
}
function Listenable$beginUse$lambda() {
  return Unit_instance;
}
function beginUse() {
  return this.tah(Listenable$beginUse$lambda);
}
var ListenableClass;
function Listenable() {
  if (ListenableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Listenable');
    ListenableClass = $;
  }
  return ListenableClass;
}
function get_state() {
  return _ReactiveState___init__impl__fvdp9b(this.f2());
}
function getValue(thisRef, property) {
  return this.f2();
}
var ReactiveValueClass;
function ReactiveValue() {
  if (ReactiveValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ReactiveValue', VOID, VOID, [Reactive()]);
    ReactiveValueClass = $;
  }
  return ReactiveValueClass;
}
function addAndRunListener(_this__u8e3s4, listener) {
  var remover = _this__u8e3s4.tah(listener);
  listener();
  return remover;
}
function valueSet(value) {
  this.mam(value);
}
function set(value, $completion) {
  this.mam(value);
}
function getValue_0(thisRef, property) {
  return this.f2();
}
function setValue(thisRef, property, value) {
  this.mam(value);
}
function lens_1(get, set) {
  return SetValueLens().qap(this, get, set);
}
function lens_2(get, modify) {
  return ModifyValueLens().xap(this, get, modify);
}
var MutableReactiveValueClass;
function MutableReactiveValue() {
  if (MutableReactiveValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableReactiveValue', VOID, VOID, [MutableValue(), ReactiveValue(), MutableReactive(), ReactiveWithMutableValue()], [1]);
    MutableReactiveValueClass = $;
  }
  return MutableReactiveValueClass;
}
function set_0(value, $completion) {
  this.cak(value);
}
var MutableValueClass;
function MutableValue() {
  if (MutableValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'MutableValue', VOID, VOID, VOID, [1]);
    MutableValueClass = $;
  }
  return MutableValueClass;
}
var ReactiveWithMutableValueClass;
function ReactiveWithMutableValue() {
  if (ReactiveWithMutableValueClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ReactiveWithMutableValue', VOID, VOID, [MutableReactive(), MutableValue()], [1]);
    ReactiveWithMutableValueClass = $;
  }
  return ReactiveWithMutableValueClass;
}
//region block: exports
export {
  beginUse as beginUse146s8dwmfk72s,
  Listenable as Listenable3m4zqvjcbvczy,
  lens_0 as lens2po2j99uxhjgr,
  lens as lens2x0usmj7eco4,
  getValue_0 as getValue6qi464mhg2s5,
  lens_2 as lens26es9640ifscs,
  lens_1 as lens2e2i845xidu26,
  setValue as setValue39oxnnnmdq4h2,
  valueSet as valueSet3cf2hvvu95f3,
  MutableReactiveValue as MutableReactiveValuettf5l2qj6mxh,
  MutableReactive as MutableReactive2qdhhyljdknhy,
  getValue as getValue1utl0kjcx26k4,
  get_state as get_state389x218zizu8a,
  ReactiveValue as ReactiveValue37mnzha3zo6xb,
  ReactiveWithMutableValue as ReactiveWithMutableValue1h1r6ig7acce5,
  Reactive as Reactive1jy75v4li6ldv,
  addAndRunListener as addAndRunListener8g331b1wn43q,
  set as set1y8eiqnqugbz3,
  set_0 as set1ugseoes1jrmg,
  Companion_getInstance as Companion_getInstancec4l82qvpwbuq,
};
//endregion

//# sourceMappingURL=coreInterfaces.mjs.map
